import { isEmpty } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { fetchChannel } from 'shared/api/channels'
import ChannelPageContext from 'shared/components/context/channel-page'
import RefreshDataContext from 'shared/components/context/refresh-data'
import StickerEmbedModalContainer from 'shared/containers/sticker-embed-modal'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { IChannel } from 'shared/types/channel'
import { setGTADataLayer } from 'shared/util/analytics'
import Channel from './channel'

const App = ({ query, isOwner, contextId: channelType, id }) => {
    const [channel, setChannel] = useState<IChannel>()
    const [deepRefreshKey, setDeepRefreshKey] = useState(0)
    const isTagView = channelType === 'tagged_channel'
    const isSearch = !isEmpty(query)
    useAsyncEffect(async () => {
        if (channelType === 'video_channel') {
            setChannel(await fetchChannel(id, 'videos'))
        } else {
            setChannel(await fetchChannel(id))
        }
    }, [])
    const { onRefreshChannel } = useContext(RefreshDataContext)
    useEffect(() => {
        if (channel) {
            const off = onRefreshChannel((refreshedChannel, deepRefresh) => {
                if (refreshedChannel.id === channel.id) {
                    // used to indicate to grids that they gotta refresh (can circle back on this, not the best approach)
                    setDeepRefreshKey(deepRefresh ? deepRefreshKey + 1 : deepRefreshKey)
                    setChannel(refreshedChannel)
                }
            })
            return off
        }
    }, [channel])
    useEffect(() => {
        // logs for pageview
        setGTADataLayer({ dimension: `ChannelPage`, value: id })
    }, [id])
    return channel ? (
        <ChannelPageContext.Provider
            value={{
                isOwner,
                channel,
                channelType,
                isTagView,
                isSearch,
                searchQuery: query,
            }}
        >
            <StickerEmbedModalContainer channelId={parseInt(id)} />
            <Channel deepRefreshKey={deepRefreshKey} />
        </ChannelPageContext.Provider>
    ) : null
}

export default App
